import React from "react";
import RichText from "@qlik/qlik/src/components/RichText";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import * as styles from "./styles.module.css";

const RichTextContainer = ({ data }) => {
    const { id, customId, title, additionalConfiguration, backgroundColor, body } = data ?? {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration);
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    return (
        (body?.raw || title) && (
            <section
                id={customId || id} // id & data-section required for inner-page-navigation
                data-section
                className={`${styles.richtextContentContainer} richtext-content scroll-mt-15 ${sectionSpacingClassName} ${sectionColorMapping.bgColor} ${sectionColorMapping.primaryTextColor}`}
            >
                <div className="container">
                    {title && <h2 className="mb-5 lg:mb-7.5 lg:mx-25">{title}</h2>}
                    <RichText data={data} className="lg:mx-25" />
                </div>
            </section>
        )
    );
};
export default RichTextContainer;
